<!-- PaymentIcon.vue -->
<template>
  <svg :class="iconClass" width="32" height="32" viewBox="0 0 32 32" fill="none">                
    <rect width="32" height="32" rx="16" fill="#F2F2F2"/>
    <g clip-path="url(#clip0_4_1201)">
    <path d="M20.308 23.3849H11.6921C11.5305 23.3849 11.3705 23.3531 11.2212 23.2912C11.0719 23.2294 10.9362 23.1387 10.822 23.0244C10.7077 22.9101 10.6171 22.7743 10.5554 22.625C10.4936 22.4757 10.4618 22.3156 10.4619 22.154V11.077H21.5382V22.154C21.5382 22.4803 21.4086 22.7932 21.1779 23.0239C20.9471 23.2546 20.6342 23.3849 20.308 23.3849Z" fill="#FCD9E2" stroke="#ED0040" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.1538 19.6921V14.7698" stroke="#ED0040" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.8462 19.6921V14.7698" stroke="#ED0040" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 11.077H24" stroke="#ED0040" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.8466 8.61511H14.1545C13.9929 8.61511 13.8329 8.64696 13.6836 8.70883C13.5343 8.77069 13.3986 8.86138 13.2844 8.97569C13.1701 9.09 13.0795 9.2257 13.0178 9.37504C12.956 9.52438 12.9242 9.68443 12.9243 9.84605V11.0763H19.0776V9.84605C19.0776 9.51977 18.9479 9.20686 18.7172 8.97615C18.4865 8.74544 18.1736 8.61582 17.8473 8.61582L17.8466 8.61511Z" fill="#FCD9E2" stroke="#ED0040" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_4_1201">
    <rect width="18" height="18" fill="white" transform="translate(7 7)"/>
    </clipPath>
    </defs>
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>
